<template>
  <form
    ref="form"
    data-url="/sendRequest"
    :class="{ 'loading-opacity': preloader }"
    enctype="multipart/form-data"
  >
    <div class="row" v-if="status == 116">
      <div class="col-12" v-if="observations.length > 0">
        <div class="form-group">
          <legend>
            <label class="text-primary">Observaciones</label>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col">OBSERVACIÓN</th>
                <th scope="col" class="text-center" style="width: 20%">
                  USUARIO
                </th>
                <th scope="col" class="text-center" style="width: 15%">
                  FECHA
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, obs) in observations" :key="obs">
                <td>{{ value.observation }}</td>
                <td class="text-center">{{ value.user.full_name }}</td>
                <td class="text-center">
                  {{ value.created_at | dateFormat }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <app-note
          class="mb-primary"
          :show-title="false"
          content-type="html"
          :notes="[$store.getters.getTag('7.I.1')]"
        />
      </div>
    </div>

    <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5 v-html="$store.getters.getTag('7')"></h5>
      </legend>
    </div>

    <div class="row" v-if="org.organization_type == 'public'">
      <div class="col-12">
        <app-note
          class="mb-primary"
          :show-title="false"
          content-type="html"
          :notes="[$store.getters.getTag('7.I.2')]"
        />
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Solicitar</label>
          <app-input
            type="select"
            v-model="request.value"
            :list="request.list"
            :disabled="disabled || request.disabled"
          />
        </div>
      </div>

      <div class="col-md-6 pt-3" v-if="!request.disabled">
        <button
          type="button"
          v-on:click="onRequest"
          class="btn btn-primary mt-4"
        >
          Solicitar
        </button>
      </div>

      <div class="col-12">
        <app-note
          class="mb-primary"
          :show-title="false"
          content-type="html"
          :notes="[$store.getters.getTag('7.I.3')]"
        />
      </div>

      <div class="col-md-6" v-if="request.invoice">
        <div class="form-group">
          <label>Factura</label>
          <button
            type="submit"
            class="btn btn-success"
            @click.prevent="openTab(request.invoice)"
          >
            <app-icon name="file" />
            {{ $t("view") }}
          </button>
        </div>
      </div>

      <div class="col-md-6" v-if="request.proform">
        <div class="form-group">
          <label>Proforma</label>
          <button
            type="submit"
            class="btn btn-success"
            @click.prevent="openTab(request.proform)"
          >
            <app-icon name="file" />
            {{ $t("view") }}
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Es Convenio</label>
          <app-input
            type="radio-buttons"
            v-model="inputs.is_agreement"
            :list="confirm"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6" v-if="inputs.is_agreement">
        <div class="form-group">
          <label
            >Persona con quien tramitó el convenio<b
              class="text-danger ml-2"
              style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input
            type="select"
            v-model="inputs.technical_manager_id"
            :required="true"
            :list="$store.getters.getTechnicalManagers()"
            :disabled="disabled"
          />
        </div>
      </div>
    </div>

    <div class="row" v-if="!inputs.is_agreement">
      <div class="col-md-6">
        <div class="form-group">
          <label
            >Razón Social<b
              class="text-danger ml-2"
              style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input
            type="text"
            v-model="inputs.i_business_name"
            :required="true"
            :disabled="disabled"
            placeholder="Ingrese el nombre o razón social"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label
            >Tipo de Identificación<b
              class="text-danger ml-2"
              style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input
            type="select"
            v-model="inputs.i_taxid_type"
            v-on:change="onChangeTaxid"
            :required="true"
            :list="taxidTypeLists"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label
            >RUC<b class="text-danger ml-2" style="font-size: 18px !important"
              >*</b
            ></label
          >
          <!-- <app-input
            type="text"
            v-model="inputs.i_taxid"
            :required="true"
            :disabled="disabled"
            placeholder="Ingrese el RUC"
            @keyup="onChangeTaxid"
          /> -->
          <app-input
            type="text"
            v-model="inputs.i_taxid"
            :required="true"
            :disabled="disabled"
            placeholder="Ingrese el RUC"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label
            >País<b class="text-danger ml-2" style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input
            type="select"
            v-model="inputs.i_country_id"
            :list="[
              { id: '', value: this.$t('select_option') },
              ...this.$store.state.common.countries,
            ]"
            :required="true"
            :disabled="disabled"
          />
        </div>
      </div>

      <div
        class="col-md-6"
        v-if="inputs.i_country_id && provinceList.length <= 1"
      >
        <div class="form-group">
          <label
            >Ciudad<b
              class="text-danger ml-2"
              style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input
            type="text"
            v-model="inputs.i_city"
            placeholder="Ingrese la ciudad"
            :required="true"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6" v-if="provinceList.length > 1">
        <div class="form-group">
          <label
            >Provincia<b
              class="text-danger ml-2"
              style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input
            type="select"
            v-model="inputs.i_province_id"
            :list="[
              { id: '', value: this.$t('select_option') },
              ...provinceList,
            ]"
            :required="true"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6" v-if="provinceList.length > 1">
        <div class="form-group">
          <label
            >Ciudad<b
              class="text-danger ml-2"
              style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input
            type="select"
            v-model="inputs.i_canton_id"
            :list="[{ id: '', value: this.$t('select_option') }, ...cantonList]"
            :required="true"
            :disabled="disabled"
            placeholder="Ingrese la ciudad"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label
            >E-mail<b
              class="text-danger ml-2"
              style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input
            type="email"
            v-model="inputs.i_email"
            placeholder="Ingrese su email"
            :required="true"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label
            >Teléfono<b
              class="text-danger ml-2"
              style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input
            type="tel-input"
            v-model="inputs.i_phone"
            :required="true"
            :disabled="disabled"
            placeholder="Ingrese el teléfono"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label
            >Dirección<b
              class="text-danger ml-2"
              style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input
            type="textarea"
            v-model="inputs.i_address"
            :required="true"
            :disabled="disabled"
            placeholder="Ingrese la dirección"
          />
        </div>
      </div>
    </div>

    <div class="row" v-if="!inputs.is_agreement">
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5 v-html="$store.getters.getTag('7.1')"></h5>
      </legend>

      <div class="col-md-12">
        <app-note
          class="mb-primary"
          :title="$t('information')"
          content-type="html"
          :notes="[$store.getters.getTag('7.I.4')]"
        />
      </div>
    </div>

    <div class="row" v-if="!inputs.is_agreement">
      <div class="col-md-6">
        <div class="form-group">
          <label
            >{{ $t("bank")
            }}<b class="text-danger ml-2" style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input
            type="select"
            v-model="inputs.bank_id"
            :required="true"
            :list="[
              { id: '', value: this.$t('select_option') },
              ...this.$store.state.accreditation.bank.map((item) => {
                return {
                  id: item.id,
                  value: `${item.name} - ${item.account_number}`,
                };
              }),
            ]"
            @change="onKeyUp"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-6" v-if="!inputs.is_agreement">
        <div class="form-group">
          <label
            >{{ $t("transaction_type")
            }}<b class="text-danger ml-2" style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input
            type="select"
            v-model="inputs.transaction_type_id"
            :required="true"
            :list="[
              { id: '', value: this.$t('select_option') },
              ...this.$store.state.accreditation.transactionType.map((item) => {
                return {
                  id: item.id,
                  value: item.name,
                };
              }),
            ]"
            :disabled="disabled"
          />
        </div>
      </div>
    </div>

    <div class="row" v-if="!inputs.is_agreement">
      <div class="col-md-12">
        <app-note
          class="mb-primary"
          :title="$t('note')"
          content-type="html"
          :notes="[$store.getters.getTag('7.I.5')]"
        />
      </div>
    </div>

    <div class="row" v-if="!inputs.is_agreement">
      <div class="col-md-6">
        <label
          >{{ $t("transaction_date")
          }}<b class="text-danger ml-2" style="font-size: 18px !important"
            >*</b
          ></label
        >
        <app-input
          type="date"
          v-model="inputs.date"
          :placeholder="$t('select_valid_date')"
          :disabled="disabled"
        />
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label
            >{{ $t("transaction_number")
            }}<b class="text-danger ml-2" style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input
            type="text"
            v-model="inputs.number"
            placeholder="Ingrese el numero de comprobante"
            :required="true"
            :disabled="disabled"
            @keyup="onKeyUp"
          />
          <span :class="classes" v-if="msgNumber"> {{ msgNumber }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6" v-if="!inputs.is_agreement">
        <div class="form-group">
          <label
            >{{ $t("amount")
            }}<b class="text-danger ml-2" style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input
            type="number"
            v-model="inputs.amount"
            placeholder="Ingrese el monto"
            :required="true"
            :disabled="disabled"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label
            >{{ inputs.is_agreement ? "Convenio" : $t("proof_payment")
            }}<b class="text-danger ml-2" style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input
            type="file"
            :label="inputs.file ? inputs.file.name : $t('upload_your_file')"
            v-model="inputs.file"
            v-if="!inputs.attached_file"
            :disabled="disabled"
            :required="true"
          />
          <div>
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs.attached_file)"
              v-if="inputs.attached_file"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="deleteModal = true"
              v-if="inputs.attached_file && !disabled"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />

    <div class="row" v-if="!disabled">
      <div class="col-12 mt-3">
        <button
          type="submit"
          class="btn btn-primary mr-2"
          @click.prevent="submit"
        >
          {{ $t("save") }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
export default {
  mixins: [FormMixin],

  data() {
    return {
      preloader: false,
      inputs: {
        is_agreement: 0,
      },
      bankList: [],
      transactionTypeList: [],
      deleteModal: false,
      msgNumber: null,
      classes: "",
      confirm: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      observations: [],
      provinceList: [],
      cantonList: [],
      i_taxid: false,
      delayTimer: null,
      taxidTypeLists: [
        { id: "", value: "Seleccione" },
        { id: "ruc", value: "RUC" },
        { id: "other", value: "Otros" },
      ],
      request: {
        value: null,
        list: [
          { id: null, value: "Seleccione" },
          { id: "F", value: "Factura" },
          { id: "P", value: "Proforma" },
          { id: "FP", value: "Factura y Proforma" },
        ],
        disabled: false,
        invoice: null,
        proform: null,
      },
    };
  },

  computed: {
    status() {
      return this.$store.state.accreditation.app
        ? this.$store.state.accreditation.app.status.code
        : null;
    },

    disabled() {
      return !["100", "116"].includes(this.status);
    },

    org() {
      return this.$store.state.accreditation.org
        ? this.$store.state.accreditation.org
        : {};
    },
  },

  watch: {
    "inputs.i_country_id": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.i_country_id
      );
    },

    "inputs.i_province_id": function () {
      this.cantonList = this.$store.getters.getCantons(
        this.inputs.i_province_id
      );
    },

    "$store.state.common.countries": function () {
      if (this.inputs.i_country_id) {
        this.provinceList = this.$store.getters.getProvinces(
          this.inputs.i_country_id
        );
        this.cantonList = this.$store.getters.getCantons(
          this.inputs.org.i_province_id
        );
      }
    },

    "$store.state.accreditation.app": function () {
      this.checkRequest();
    },
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },

  created() {
    this.inputs.date = new Date();
    this.checkRequest();
    this.data();
  },

  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      /* if (
        !this.inputs.is_agreement &&
        this.inputs.i_taxid_type == "ruc" &&
        !this.i_taxid
      ) {
        this.$toastr.e("El RUC no es valido");
        return;
      } */

      if (this.classes == "text-danger") return;

      const tmp = { ...this.inputs };

      if (tmp.date) {
        const d = tmp.date;
        tmp.date = [d.getFullYear(), d.getMonth() + 1, d.getDate()].join("-");
      }

      let formData = new FormData();
      for (const [key, value] of Object.entries(tmp)) {
        formData.append(key, value);
      }
      formData.append(
        "accreditation_application_id",
        this.$store.state.accreditation.id
      );

      this.save(formData);
    },

    afterSuccess({ data: data }) {
      // this.$toastr.s(res.data.message);
      const { deposit, observations, status } = data;
      this.inputs = deposit;
      this.inputs.date = new Date(deposit.date);
      this.inputs.technical_manager_id =
        deposit.accreditation_application.technical_manager_id;
      this.$toastr.s(this.$t("updated_success"));
      this.$store.dispatch("getAccApp");
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {
      this.$store.dispatch("getSendRequestOptions");
      this.$store.dispatch("getPoliticalDivision");
      this.$store.dispatch("getTechnicalManagers");

      this.preloader = true;

      this.axiosGet(
        `/sendRequest/show?accreditation_application_id=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200 && response.data) {
            const { deposit, observations, status } = response.data;
            if (status && status.code == 116) {
              this.observations = observations;
              if (deposit.is_approved != 3) {
                this.inputs = deposit;
                this.inputs.date = new Date(this.inputs.date);
              }
            } else if (deposit) {
              this.inputs = deposit;
              this.inputs.date = new Date(this.inputs.date);
            }
            this.inputs.technical_manager_id =
              deposit.accreditation_application.technical_manager_id;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    confirmed() {
      this.deleteModal = false;
      this.inputs.file = null;
      this.inputs.attached_file = null;
      this.inputs.delete_file = 0;
    },

    cancelled() {
      this.deleteModal = false;
    },

    openTab(file) {
      const w = window.open(file.path, "_blank");
      w.focus();
    },

    onKeyUp() {
      if (this.inputs.bank_id != null && this.inputs.number != null) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(this.ckeck, 1000);
      } else {
        this.msgNumber = null;
      }
    },

    ckeck() {
      this.msgNumber = "";
      clearTimeout(this.delayTimer);
      const url = `treasury/deposits/validateDeposit/${this.inputs.number}/${this.inputs.bank_id}`;
      this.axiosGet(url).then((response) => {
        if (response.status == 200) {
          const { validate } = response.data;
          if (validate) {
            this.msgNumber = "Comprobante valido";
            this.classes = "text-success";
          } else {
            this.msgNumber = "Comprobante registrado";
            this.classes = "text-danger";
          }
        }
      });
    },

    dateToString(date) {
      return date != null ? moment(date).format("YYYY-MM-DD") : null;
    },

    onChangeTaxid() {
      if (
        this.inputs.i_taxid_type &&
        this.inputs.i_taxid &&
        this.inputs.i_taxid_type == "ruc"
      ) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => {
          if (this.inputs.i_taxid.length != 13) {
            this.$toastr.e("El campo RUC debe tener 13 digitos");
            return;
          }
          this.validateTaxid(this.inputs.i_taxid);
        }, 1000);
      }
    },

    validateTaxid(taxid) {
      this.preloader = true;
      let url = `/register/users/validateRucPayment/${taxid}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            if (!response.data.validate) {
              this.$toastr.e(response.data.message);
            }

            this.i_taxid = response.data.validate;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    checkRequest() {
      const accApp = this.$store.state.accreditation.app;
      if (accApp) {
        this.$store.state.accreditation.org =
          this.$store.state.accreditation.app.organization;
        this.request.value = accApp.request;
        this.request.disabled = accApp.request != null;
        this.request.invoice = accApp.request_invoice;
        this.request.proform = accApp.request_proform;
      }
    },

    onRequest() {
      if (this.request) {
        this.preloader = true;
        let url = `/accreditations/applications/requestDocument?accAppId=${this.$store.state.accreditation.id}&req=${this.request.value}`;
        this.axiosGet(url)
          .then((response) => {
            if (response.status == 200) {
              this.$toastr.s("Solicitud enviada con éxito");
              this.$store.dispatch("getAccApp");
            }
          })
          .catch((error) => {
            this.$toastr.e("Error al tratar de enviar la solicitud");
            console.log(error);
          })
          .finally(() => {
            this.preloader = false;
          });
      }
    },
  },
};
</script>